export const SESSION_EXPIRED_QUERY_PARAM = "sessionExpired";
export const SESSION_EXPIRATION_MESSAGE = "Logout has occurred due to Track Labs session expiration.";

/**
 * Limits post-login redirects to authenticated workspace roots. This keeps the
 * session-expiry notice from turning an untrusted query parameter into an
 * arbitrary redirect destination.
 */
export function isWorkspaceReturnPath(value: string | null | undefined): value is string {
  if (!value) return false;
  if (value === "/app" || value.startsWith("/app?")) return true;
  return /^\/tenant\/[^/?#]+(?:\/(?:pages|forms)\/[^/?#]+)?(?:\?.*)?$/.test(value);
}

/** Builds the login destination used only when a Track Labs session expires. */
export function buildSessionExpiredLoginPath(returnPath?: string | null) {
  const params = new URLSearchParams({ [SESSION_EXPIRED_QUERY_PARAM]: "1" });
  if (isWorkspaceReturnPath(returnPath)) params.set("return", returnPath);
  return `/login?${params.toString()}`;
}

/** True only for the explicit, one-time session-expiration login notice. */
export function hasSessionExpiredNotice(search: string) {
  return new URLSearchParams(search).get(SESSION_EXPIRED_QUERY_PARAM) === "1";
}
